import { render, staticRenderFns } from "./CapexMetricConfigurationPage.vue?vue&type=template&id=876b06de"
import script from "./CapexMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./CapexMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports